import { Trans } from "react-i18next";
import { Button, Paper } from "@mui/material";
import styled from "styled-components/macro";
import { useOpenAssistant } from "./assistantHooks";
import TransVariable from "components/other/TransVariable";
import { AssistantMode } from "./__generated__/AssistantMutation.graphql";
import { MAX_LISTEN_VOCAB_CARDS } from "sharedJs__generated/constants";

export const getChatMaxMessages = (mode: AssistantMode) => {
  if (mode === "listenVocab") {
    return MAX_LISTEN_VOCAB_CARDS;
  }
  return 30; // 0.1-0.2% of users
};

export const MAX_MESSAGE_LENGTH = 3000;

const Wrap = styled(Paper)`
  margin: 10px 10px 20px 10px;
  padding: 10px;
  background-color: #fff3f3;
  text-align: center;
`;
const Div = styled.div`
  margin: 10px;
`;
const Warn = styled.div`
  color: orange;
  padding: 2px 6px 6px;
  font-size: 80%;
  line-height: 1.4em;
`;

export const FullChat = ({ mode }: { mode: AssistantMode }) => {
  const openAssistant = useOpenAssistant();
  const maxUserMessages = getChatMaxMessages(mode);
  const maxMessages = mode === "listenVocab" ? maxUserMessages : maxUserMessages * 2; // in listen vocab mode are visible only assistant messages

  return (
    <Wrap>
      <Trans parent={Div}>
        You reached the maximum of <TransVariable text={String(maxMessages)} /> messages for one chat.
      </Trans>

      <Button variant="contained" color="primary" size="small" onClick={() => openAssistant()}>
        <Trans>Start a new chat</Trans>
      </Button>
    </Wrap>
  );
};

export const FullChatWarning = ({ messagesCount, mode }: { messagesCount: number; mode: AssistantMode }) => {
  const maxMessages = getChatMaxMessages(mode);
  if (mode === "listenVocab") return null; // no need for warning in this mode

  if (messagesCount >= maxMessages - 3 && messagesCount < maxMessages) {
    return (
      <Warn>
        <Trans>This chat is reaching its limit. You can ask few more questions.</Trans> ({maxMessages - messagesCount})
      </Warn>
    );
  }
  return null;
};
